export default "__VITE_PUBLIC_ASSET__21632ca2__"